import React, { useState, useEffect, useRef } from 'react';
import UserTestimonial from './UserTestimonial';
import LandingSection from './LandingSection';
import Carousel from './Carousel';

// Animated counter hook
const useCountUp = (end, duration = 2000, startOnView = true) => {
  const [count, setCount] = useState(0);
  const [hasStarted, setHasStarted] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!startOnView) {
      setHasStarted(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasStarted) {
          setHasStarted(true);
        }
      },
      { threshold: 0.3 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [hasStarted, startOnView]);

  useEffect(() => {
    if (!hasStarted) return;

    let startTime;
    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const easeOut = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(easeOut * end));
      if (progress < 1) requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);
  }, [hasStarted, end, duration]);

  return { count, ref };
};

const testimonialData = [
    {
        quote: "Very clean way to see what people are actually saying about the business.",
        title: "Hedge Fund Analyst"
    },
    {
        quote: "Incredibly useful tool for quickly getting up to speed on a business.",
        title: "Private Equity Associate"
    },
    {
        quote: "Parses through all the chaos/noise.",
        title: "Hedge Fund Analyst"
    },
    {
        quote: "Saves me a ton of time and finds info you'll never get in a filing or presentation.",
        title: "Private Equity Associate"
    },
    {
        quote: "Works as advertised!",
        title: "Private Equity Associate"
    },
    {
        quote: "Really impressed by the tool and excited to use it more.",
        title: "Private Equity Associate"
    },
    {
        quote: "Very cool.",
        title: "Investment Banker"
    },
    {
        quote: "I like this a lot!",
        title: "Hedge Fund Analyst"
    }
];

const UserTestimonials = () => {
  const aumCounter = useCountUp(250, 2000);
  const percentCounter = useCountUp(25, 1800);

  const renderTestimonial = (testimonial, isActive) => (
    <UserTestimonial {...testimonial} isActive={isActive} />
  );

  return (
    <div className="testimonials-section sine-background">
      <LandingSection
        title="Trusted by investors at leading firms"
        subtitle="Investors at top investment funds use Scuttlebutt to enhance their diligence process, get signal on companies, avoid costly bespoke surveys, and save time."
        customContent={
          <div className="testimonials-container">
            <div className="market-stats-banner">
              <div className="market-metric" ref={aumCounter.ref}>
                <div className="metric-number">${aumCounter.count}B+</div>
                <div className="metric-description">Total AUM of firms that use Scuttlebutt</div>
              </div>
              <div className="market-metric" ref={percentCounter.ref}>
                <div className="metric-number">{percentCounter.count}%</div>
                <div className="metric-description">of the largest PE firms and hedge funds in the US have team members using Scuttlebutt</div>
              </div>
            </div>

            <Carousel
              items={testimonialData}
              renderItem={renderTestimonial}
              className="testimonial-carousel"
              slideClassName="testimonial-slide"
              containerClassName="testimonial-slides-container"
              autoPlayInterval={5000}
            />
          </div>
        }
        id="testimonials"
      />
    </div>
  );
};

export default UserTestimonials; 